// WorkerProfileDrawer.jsx
import React, { useState, useMemo, useEffect } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/WorkerProfileDrawer.css';
import WorkerAttendanceCalendar from './WorkerAttendanceCalendar';
import PaymentHistoryTable from './PaymentHistoryTable';
import MarkAttendanceModal from './MarkAttendanceModal'
import LogPaymentModal from './LogPaymentModal';
import EditWorkerModal from './EditWorkerModal';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteWorker, fetchWorkers, getWorkerAttendance, getWorkerPayments, refreshLaborProject, } from '../../../../../../../Redux/Projects/Labor/laborSlice';

const WorkerProfileDrawer = ({ worker: initialWorker, onClose }) => {


  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const dispatch = useDispatch();
  const { projectId } = useParams(); // used to refetch after delete
  const { workers } = useSelector((state) => state.labor);
  const { attendance } = useSelector((state) => state.labor);
  const { payments } = useSelector((state) => state.labor);




  // 👇 Sync with Redux (fresh worker after update)
  const latestWorker = useMemo(() => {
    return workers.find((w) => w._id === initialWorker._id) || initialWorker;
  }, [workers, initialWorker._id]);

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this worker?')) {
      await dispatch(deleteWorker(latestWorker._id));
      await dispatch(refreshLaborProject(projectId));// refresh list
      onClose(); // close drawer
    }
  };


  useEffect(() => {
    if (latestWorker?._id) {
      dispatch(getWorkerAttendance(latestWorker._id));  // ✅ Will populate Redux
      dispatch(getWorkerPayments({ workerId: latestWorker._id, projectId }));
    // ✅ Still needed
    }
  }, [dispatch, latestWorker._id]);


  useEffect(() => {
    // lock page scroll while drawer is open
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);


  const attendanceData = attendance[latestWorker._id] || {};


  if (!latestWorker) return null;

















  const handleLogPayment = (paymentData) => {
    console.log('Logged payment:', paymentData);
    // Optional: Save to localStorage or state
  };



  return (
    <div className="worker-drawer-overlay blur-backdrop" onClick={(e) => {
      if (e.target === e.currentTarget) onClose(); // click outside to close
    }}>
      <div className="worker-drawer slide-in">
        <div className="worker-drawer-header">
          <h3>Worker Profile</h3>
          <button className="worker-drawer-close" onClick={onClose}>X</button>
        </div>


        {/* Profile Card */}
        <div className="worker-drawer-profile-card">
          <img
            src={latestWorker.avatar || 'https://i.ibb.co/j3pW4yv/user.png'} // Use placeholder or avatar
            alt="Profile"
            className="worker-drawer-avatar"
          />
          <div className="worker-drawer-info">
            <div className="worker-drawer-name">{latestWorker.firstName} {latestWorker.lastName}</div>
            <div className="worker-drawer-role">
              {latestWorker.role} &nbsp; ₹{latestWorker.wages}/day
              <span className="worker-drawer-status active">Active</span>
            </div>
            <div className="worker-drawer-phone">+91 {latestWorker.phone || 'XXXXXXXXXX'}</div>
          </div>
        </div>


        <div className="worker-drawer-actions">
          <button className="worker-drawer-btn" onClick={() => setShowEditModal(true)}>Edit</button>
          <button className="worker-drawer-btn" onClick={handleDelete}>Delete</button>
        </div>

        <br></br>
        <br></br>

        <div className="worker-drawer-attendance">
          <WorkerAttendanceCalendar attendance={attendanceData} />
        </div>

        <div className="worker-drawer-payments">
          <PaymentHistoryTable payments={payments[latestWorker._id] || []} />
        </div>

        <div className="worker-drawer-footer">
          <button className="btn red" onClick={() => setShowAttendanceModal(true)}>Mark Attendance</button>
          <button className="btn black" onClick={() => setShowPaymentModal(true)}>Log Payment</button>
        </div>
      </div>


      {showAttendanceModal && (
        <MarkAttendanceModal
          workerId={latestWorker._id}
          workerName={`${latestWorker.firstName} ${latestWorker.lastName}`}
          projectId={projectId}   // ✅ add this
          onClose={() => setShowAttendanceModal(false)}
        />
      )}


      {showPaymentModal && (
        <LogPaymentModal
          worker={{ _id: latestWorker._id, firstName: latestWorker.firstName, lastName: latestWorker.lastName }}
          projectId={projectId}   // ✅ add this
          onClose={() => setShowPaymentModal(false)}
        />
      )}


      {showEditModal && (
        <EditWorkerModal
          worker={latestWorker}
          onClose={() => setShowEditModal(false)}
        />
      )}

    </div>
  );
};

export default WorkerProfileDrawer;
